import { z } from "zod";
import { parseDentes } from "../odontograma/denticao";

export const MAX_QUANTIDADE_DO_SERVICO = 64;
export const quantidadeDoServicoSchema = z.number().int().min(1).max(MAX_QUANTIDADE_DO_SERVICO);

/** Quantidade padrão do serviço: uma por dente marcado (7 coroas = 7). Serviço de arcada e dente
 *  em texto livre contam 1 — o laboratório corrige quando não for o caso. */
export function quantidadePadrao(teeth: string | null | undefined, abrangencia?: string | null): number {
  if (abrangencia === "ARCADA") return 1;
  return Math.min(Math.max(parseDentes(teeth).length, 1), MAX_QUANTIDADE_DO_SERVICO);
}

export type ServicoComValor = { priceCents: number | null; quantidade?: number | null };

/** `priceCents` é o unitário; o serviço vale preço × quantidade. Nulo = sem preço. */
export const valorDoServico = (s: ServicoComValor): number | null =>
  s.priceCents == null ? null : s.priceCents * Math.max(s.quantidade ?? 1, 1);

/** Total do pedido (serviços com preço + acréscimos) e quantos serviços estão sem preço. */
export function totalDoPedido(servicos: ServicoComValor[], acrescimos: { valorCents: number }[] = []) {
  const doServicos = servicos.reduce((t, s) => t + (valorDoServico(s) ?? 0), 0);
  const doAcrescimos = acrescimos.reduce((t, a) => t + a.valorCents, 0);
  return { totalCents: doServicos + doAcrescimos, semPreco: servicos.filter((s) => s.priceCents == null).length };
}

/** As descrições que o "+ Acréscimo" já oferece; a pessoa digita outra se precisar. */
export const ACRESCIMOS_SUGERIDOS = ["Taxa de urgência", "Frete"] as const;

export const adicionarAcrescimoSchema = z.object({
  orderId: z.string().min(1),
  descricao: z.string().trim().min(2, "Descreva o acréscimo").max(120),
  valorCents: z.number().int().min(1, "Informe o valor").max(10_000_000),
});
export type AdicionarAcrescimoInput = z.infer<typeof adicionarAcrescimoSchema>;
